module.exports = __webpack_public_path__ + "img/straight.a8b5e931.png";